import { render, staticRenderFns } from "./MarketingPost.vue?vue&type=template&id=68c9d54d&scoped=true&"
import script from "./MarketingPost.vue?vue&type=script&lang=js&"
export * from "./MarketingPost.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPost.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MarketingPost.vue?vue&type=style&index=1&id=68c9d54d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c9d54d",
  null
  
)

export default component.exports